export default __webpack_public_path__ + "static/FranklinGothic-Demi-0e252610c8abe43049dd59dd4cec1eb8.woff";